import React from 'react'
import { inject, observer } from 'src/core/store'
import './index.less'
import { setDocumentTitle, setUidToken } from 'src/helper/tool'
import lang from './lang'
import { getlang, setlang } from 'src/helper/getlang'
import ReminderBtn from 'src/component/myRuleButton'
import Toast from 'src/component/Toast'
import http from 'src/helper/http'
import { jumpToUser, jumpToWallet } from '../../../helper/webviewFun'
@inject('store')
@observer
export default class Couples extends React.Component {
  constructor(props) {
    super(props)
  }
  state = {
    lang: lang.en,
    language: 'en',
    minute: '0',
    day: '0',
    hour: '0',
    second: '0',
    selectItem: 0,
    dailyList: [],
    dailyTotal: '0',
    mothGoldList: [],
    goldItem: 0,
    okSuss: {
      en: 'Received',
      ar: 'تم الإستلام',
      tr: 'Alındı',
      zh: 'Received',
    },
    errSuss: {
      en: 'Get failed',
      ar: 'فشل',
      tr: 'Alma Başarısız',
      zh: 'Received',
    },
    monthlyTotal: '',
    rubyRewardList: [],
    rubyNum: '',
    toastContent:'Received',
  }

  async componentDidMount() {
    let { language } = this.props.location.query
    language =await getlang(language)
    const uid = await setUidToken(this.props.location.query)
    if (language == 'tr') {
      setDocumentTitle('Çekim Ödülleri')
    }else if (language == 'ar') {
      setDocumentTitle('جوائز التصنيف')
    }else{
      setDocumentTitle('Recharge rewards')
    }
    this.setState({
      lang: setlang(language, lang),
      language: language,
      uid,
      severId:language=='tr'?113742:977239
    })
    this.rechargeRewardList()
    this.getRubyReward()
  }

  countDown = (times = 2299085) => {
    let { lang } = this.state
    var timer = null
    timer = setInterval(() => {
      let day = 0,
        hour = 0,
        minute = 0,
        second = 0
      if (times > 0) {
        day = Math.floor(times / (60 * 60 * 24))
        hour = Math.floor(times / (60 * 60)) - day * 24
        minute = Math.floor(times / 60) - day * 24 * 60 - hour * 60
        second = Math.floor(times) - day * 24 * 60 * 60 - hour * 60 * 60 - minute * 60
      }
      if (day <= 9) day = day
      if (hour <= 9) hour = '0' + hour
      if (minute <= 9) minute = '0' + minute
      if (second <= 9) second = '0' + second
      let daystr = ''
      if (day > 0) {
        // daystr = day
        daystr = day + ' ' + lang.days
      }
      this.setState({
        minute,
        day,
        hour,
        second
      })
      times--
    }, 1000)
    if (times <= 0) {
      clearInterval(timer)
    }
  }

  hanleSelect = (e) => {
    this.setState({ selectItem: e })
  }

  rechargeRewardList = async (map, lang) => {
    let d = await http.post('/web/rechargeReward/list', map)
    if (d && d.code == 0) {
      this.setState({
        dailyTotal: d.res.dailyTotal,//月的金币领取次数
        dailyList: d.res.list.slice(0, 5),
        mothGoldList: d.res.list.slice(5, d.res.list.length),
        monthlyTotal: d.res.monthlyTotal
      })
      this.getWhitr(11,6,d.res.list.slice(5, d.res.list.length))
      this.countDown(d.res.leftTimestamp)
    }

  }

  showRulesModle = (open, close) => {
    let { lang, selectItem } = this.state
    let showRule = selectItem == 0? lang.goldRule : lang.register
    return (
      <div className="goldRubyRecharge-modle" >
        <div className='title-tip'>{lang.rule}</div>
        <div className="goldRubyRecharge-modle-body" onClick={() => close()}>
          <div
            className="ru-show-toot"
            dangerouslySetInnerHTML={{ __html: showRule }}
          ></div>
        </div>
      </div>
    )
  }
  stabilization = true
  handleGoldItem = (e) => {
    console.log(e)
    console.log(this.state.mothGoldList[e])
    this.setState({ goldItem: e })
  }

  getGoldReward = async (id) => {
    let { language, okSuss, errSuss, selectItem } = this.state
    if (!this.stabilization) return
    let httpUrl = selectItem == 0 ? '/web/rechargeReward/getReward' : '/web/rechargerubyReward/getReward'
    this.stabilization = false
    let res = await http.post(httpUrl, { rechargeLevelId: id })
    this.stabilization = true
    if (res.code == 0) {
      console.log(language,'153')
     await this.setState({
        toastContent: okSuss[language]
      })
    } else {
     await   this.setState({
        toastContent: errSuss[language]
      })
    }
    this.refs.toast.hideRule(true)
    selectItem == 0 ?this.rechargeRewardList(): this.getRubyReward()
  }

  getRubyReward = async () => {
    let res = await http.post('/web/rechargerubyReward/list')
    if (res.code == 0) {
      this.setState({ rubyRewardList: res.res.list, rubyNum: res.res.monthlyTotal })
    }
  }

  getWhitr = (e=11,w=6,arr=[],myrange)=>{
    let a = 0
    let i = (w/e).toFixed(4)/1
    let b = 0
    let c = []
    let n = []
    arr.forEach(item=>{
      c.push(item.rechargeAmount/100)
      item.canGet && a++
    })
    let j =(myrange - c[a-1])*((i/c[a]))
    b = a*i + 0.15 +(c[0]==150?a*0.04:0)+j
    return b 
  }
  render() {
    let { language, toastContent, lang, minute, day, hour, second, selectItem, dailyList, dailyTotal, mothGoldList, goldItem, monthlyTotal, rubyRewardList, rubyNum, severId } = this.state
    return (
      <div className={`gold-ruby-recharge ${language == 'ar' && 'arlang'}`}>
        <Toast
          language={language}
          lang={lang}
          ref="toast"
          id="toast"
          toastContent={toastContent}
        />
        <div className='gr-recharge-banner-root'>
          <img className='move-gif' src='/img/activity/goldRubyRecharge/move_gif_ins.gif'></img>
          <img className='banner-title-ingr'  src={`/img/activity/goldRubyRecharge/new_bro_${language=='tr'?'tr':language=='ar'?'ar':'en'}.png`}></img>
          { <ReminderBtn
            lang={lang}
            slotButtonComp={() => {
              return <div className="gr-recharge-rules">{lang.rule}</div>
            }}
            slotContentComp={this.showRulesModle}
          />}
        </div>
        <div className={`body-root ${selectItem == 0 ? 'gold-root' : 'ruby-root'}`}>
          <div className='time-root'>
            <img className='arabesques' src='/img/activity/goldRubyRecharge/time_arabesques.png'></img>
            <div className='time-text-root'>
              <div className={`text-num ${selectItem == 0 ? 'text-num-gold' : 'text-num-ruby'}`}>{day}</div>
              <div className='text-day'>{(language == 'tr' ? "Gün" : language == 'ar' ? "يوم" : 'day')}</div>
              <div className={`text-num ${selectItem == 0 ? 'text-num-gold' : 'text-num-ruby'}`}>{hour}</div>
              <div className='text-tip'>:</div>
              <div className={`text-num ${selectItem == 0 ? 'text-num-gold' : 'text-num-ruby'}`}>{minute}</div>
              <div className='text-tip'>:</div>
              <div className={`text-num ${selectItem == 0 ? 'text-num-gold' : 'text-num-ruby'}`}>{second}</div>
            </div>
            <img className='time-line-bm' src='/img/activity/goldRubyRecharge/time_line_bm.png'></img>
          </div>
          {<div className='select-gold-ruby'>
            <div className={'item-in'} onClick={() => this.hanleSelect(0)}>
              <img className={selectItem == 0 ? 'names' : 'names-on'} src={selectItem !== 0 ? '/img/activity/goldRubyRecharge/select-no.png' : '/img/activity/goldRubyRecharge/select-in.png'}></img>
              <span>{lang.gold}</span></div>
            {false && <div className={'item-in'} onClick={() => this.hanleSelect(1)}>
              <img className={selectItem == 1 ? 'names' : 'names-on'} src={selectItem !== 1 ? '/img/activity/goldRubyRecharge/select-no.png' : '/img/activity/goldRubyRecharge/rubyselect-in.png'}></img>
              <span>{lang.ruby}</span></div>}
          </div>}
          {false && selectItem == 0 && <div className='day-reward-root'>
            <div className='day-reward-title'>{lang.dailyBenefits}</div>
            <div className='day-reward-body'>
              {dailyList.length > 0 && dailyList.map((item, index) => (<div className='body-item' key={index}>
                <div className='img-root'>${item.rechargeAmount / 100}</div>
                <div className='get-num'>{item.rewardDetail && item.rewardDetail.length > 0 && item.rewardDetail[0].rewardNum}</div>
                <div className={`get-btn ${item.alreadyGet == false && item.canGet == true
                  ? 'bg1' : 'bg2'}`} onClick={() => { item.alreadyGet == false && item.canGet == true && this.getGoldReward(item.id) }} >{`${item.alreadyGet == false && item.canGet == true ? lang.get : Math.floor(dailyTotal) + '/' + item.rechargeAmount / 100}`}</div>
              </div>))}
            </div>
          </div>}
          {selectItem == 0 && <div className={`pick-upcontainers-gold${language=='ar'?'-ar':''}`} >
            <div className='day-reward-title'>{lang.monthly}</div>
            <div className='swperi-root' >
              {mothGoldList.length > 0 && mothGoldList.map((item, index) => (<div className='my-div' key={index} onClick={() => this.handleGoldItem(index)}  style={{ opacity: `${item.canGet ? '1' : '0.5'}` }}>${item.rechargeAmount / 100}</div>))}
            </div>
            <div className='progress-bar'>
              {mothGoldList.length > 0 && [{rechargeAmount:0},...mothGoldList].map((item,index) => (<div className={`progress-bar-item ${monthlyTotal>=(item.rechargeAmount/100)?'cangetrechan':''}`} key={index} style={{opacity:`${index == 0?'0':'1'}`}} ></div>))}
              <div
                   style={{width:`${(this.getWhitr(11,6,mothGoldList,monthlyTotal)).toFixed(2)}rem`,left:`${language == 'ar'?"":'0'}`,right:`${language == 'ar'?"0":''}` }}
                  className="done-prog"></div>
            </div>
          </div>}
          {selectItem == 1 && <div className={`pick-upcontainers-ruby${language=='ar'?'-ar':''}`}>
            <div className='swperi-root' >
              {rubyRewardList.length > 0 && rubyRewardList.map((item, index) => (<div className='my-div' key={index+66} onClick={() => this.handleGoldItem(index)}  style={{ opacity: `${item.canGet ? '1' : '0.5'}` }}>${item.rechargeAmount / 100}</div>))}
            </div>
            <div className='progress-bar'>
              {rubyRewardList.length > 0 && [{rechargeAmount:0},...rubyRewardList].map((item,index) => (<div  className={`progress-bar-item ${rubyNum>=(item.rechargeAmount/100)?'cangetrechan':''}`} key={index} style={{opacity:`${index == 0?'0':'1'}`}} ></div>))}
              <div
                  style={{width:`${(this.getWhitr(8,6,rubyRewardList,rubyNum)).toFixed(2)}rem`,left:`${language == 'ar'?"":'0'}`,right:`${language == 'ar'?"0":''}`}}
                  className="done-prog"></div>
            </div>
          </div>}
          {selectItem == 0 && <div className='show-reward-root'>
            <div className='name-in-grr'>{/* {lang.trFive} */}${mothGoldList[goldItem] && mothGoldList[goldItem].rewardDetail.length > 0 && mothGoldList[goldItem].rechargeAmount / 100}</div>
            <div className='reward-item'>
              {mothGoldList[goldItem] && mothGoldList[goldItem].rewardDetail.length > 0 && mothGoldList[goldItem].rewardDetail.map((item, index) => (<div className='item' key={index}>
                <div className='item-img'>
                  <img className={'reward-img' }src={item.pic}></img>
                  {item.rewardType != 'gold' && <div className='item-time' ><div>{language == 'ar' ? item.rewardNum + 'يوم' : language == 'tr' ? item.rewardNum + 'Gün' : item.rewardNum + 'day'}</div></div>}
                </div>
                <div className='item-name' style={{width:`${goldItem==9?'2.2rem':'1.74rem'}`}}>{language == 'tr' ? item.rewardNameTr : language == 'ar' ? item.rewardNameAr : item.rewardName}</div>
              </div>))}
              {mothGoldList[goldItem] && mothGoldList[goldItem].canGet && !mothGoldList[goldItem].alreadyGet && <div className='get-btn' onClick={() => this.getGoldReward(mothGoldList[goldItem].id)}>{lang.get}</div>}
              {mothGoldList[goldItem] && mothGoldList[goldItem].canGet && mothGoldList[goldItem].alreadyGet && <div className='get-btn-had' >{lang.get}</div>}
              {mothGoldList[goldItem] && !mothGoldList[goldItem].canGet && !mothGoldList[goldItem].alreadyGet && <div className='get-btn'>{`${monthlyTotal}/${mothGoldList[goldItem] && mothGoldList[goldItem].rewardDetail.length > 0 && mothGoldList[goldItem].rechargeAmount / 100}`}</div>}
            </div>
          </div>}
          {selectItem == 1 && <div className='show-reward-root-ruby'>
            <div className='name-in-grr'>${rubyRewardList[goldItem] && rubyRewardList[goldItem].rewardDetail.length > 0 && rubyRewardList[goldItem].rechargeAmount / 100}</div>
            <div className='reward-item'>
              {rubyRewardList[goldItem] && rubyRewardList[goldItem].rewardDetail.length > 0 && rubyRewardList[goldItem].rewardDetail.map((item, index) => (<div className='item' key={index} >
                <div className='item-img'>
                  <img className={`${item.rewardType == 'background'?'':"reward-img"}`} style={{maxHeight:`${item.rewardType=='background'?'1.18rem':''}`}} src={language == 'ar' ? item.picAr || item.pic : language == 'tr' ? item.picTr || item.pic : item.pic}></img>
                  {item.rewardType != 'gold' && item.rewardType != 'gift' && item.rewardType != 'duid' && item.rewardType != 'custom_flash' && item.rewardType != 'custom_gift' && <div className='gift-time'><div>{language == 'ar' ? item.rewardNum + 'يوم' : language == 'tr' ? item.rewardNum + 'Gün' : item.rewardNum + 'day'}</div></div>}
                </div>
                <div className='item-name'>{language == 'tr' ? item.rewardNameTr : language == 'ar' ? item.rewardNameAr : item.rewardName}</div>
              </div>))}
              {mothGoldList[goldItem] && rubyRewardList[goldItem].canGet && !rubyRewardList[goldItem].alreadyGet && <div className='get-btn' onClick={() => this.getGoldReward(rubyRewardList[goldItem].id)}>{lang.get}</div>}
              {rubyRewardList[goldItem] && rubyRewardList[goldItem].canGet && rubyRewardList[goldItem].alreadyGet && <div className='get-btn-had'>{lang.get}</div>}
              {rubyRewardList[goldItem] && !rubyRewardList[goldItem].canGet && !rubyRewardList[goldItem].alreadyGet && <div className='get-btn'>{`${rubyNum}/${rubyRewardList[goldItem] && rubyRewardList[goldItem].rewardDetail.length > 0 && rubyRewardList[goldItem].rechargeAmount / 100}`}</div>}
            </div>
          </div>}
          {selectItem == 0 && <div className='interactButtons'>
            <div className='recharge_bm_btn' onClick={()=>jumpToWallet(0)}>{lang.r}</div>
            <div className='call_bm_btn' onClick={()=>jumpToUser(severId)}>{lang.help}</div>
          </div>}
          {selectItem == 1 && <div className='interactButtons-ruby'>
            <div className='recharge_bm_btn' onClick={()=>jumpToWallet(2)}>{lang.r}</div>
            <div className='call_bm_btn' onClick={()=>jumpToUser(severId)}>{lang.help}</div>
          </div>}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/activity/goldRubyRecharge/index.js